function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#371447",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.556 22.343c0 1.31 1.213 2.373 2.71 2.373 1.498 0 2.712-1.063 2.712-2.373",
  strokeWidth: 1.083
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.978 13.453v8.5",
  strokeWidth: 1.083,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.235 15.453c0-6.116-5.152-11.074-11.509-11.074-6.356 0-11.509 4.958-11.509 11.074 1.178-.25 2.01-.376 2.498-.376.958 0 1.744.376 2.355.376 1.047 0 2.131-.578 3.45-.578.874 0 2.134.578 3.582.578.953 0 2.255-.485 3.456-.485 1.133 0 2.152.485 3.506.485.504 0 1.227-.43 2.096-.43.409 0 1.1.143 2.075.43z",
  strokeWidth: 1.083,
  fill: "#4DD0E1"
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.542
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.326 13.275c.164-.776.41-1.526.742-2.25.93-2.034 2.522-3.863 4.775-5.485M19.017 13.275a10.693 10.693 0 00-.742-2.25c-.93-2.034-2.522-3.863-4.775-5.485"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.648 3.1c.442 0 .8-.321.8-.718 0-.264-.266-.725-.8-1.382-.533.657-.8 1.118-.8 1.382 0 .397.358.718.8.718zM2.127 6.584c.442 0 .8-.321.8-.718 0-.264-.267-.725-.8-1.382-.534.657-.8 1.118-.8 1.382 0 .397.357.718.8.718zM24.41 6.584c.441 0 .8-.321.8-.718 0-.264-.267-.725-.8-1.382-.534.657-.801 1.118-.801 1.382 0 .397.358.718.8.718zM17.561 3.1c.442 0 .8-.321.8-.718 0-.264-.266-.725-.8-1.382-.533.657-.8 1.118-.8 1.382 0 .397.358.718.8.718z",
  strokeWidth: 0.542
}));

function SvgEmergenciesSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgEmergenciesSm;